<template>
  <p
    class="message"
    :class="{
      message_error: type === 'error',
      message_warning: type === 'warning',
      message_success: type === 'success',
    }"
  >
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      validator: value => ['error', 'warning', 'success'].includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.message {
  border-radius: 2px;
  padding: 3px 10px;
  text-align: center;
  line-height: 18px;

  @include notebook {
    margin: 10px 0;
  }

  &_error {
    background: var(--bg-error);
    color: var(--text-error-contrast);
  }

  &_warning {
    background: var(--bg-warning);
    color: var(--text-warning-contrast);
  }

  &_success {
    background: var(--bg-success);
    color: var(--text-success-contrast);
  }
}
</style>
